import { render, staticRenderFns } from "./TireCamera.vue?vue&type=template&id=27ef2a20"
import script from "./TireCamera.vue?vue&type=script&lang=ts"
export * from "./TireCamera.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports